import { useCallback } from "react";

const useShowToast = () => {
  const showToast = useCallback((title, description, status) => {
    console.log({
      title: title,
      description: description,
      status: status
    });
	alert(title + description + status);
  });
  return showToast;
};

export default useShowToast;
